module.exports = __webpack_public_path__ + "static/media/lockytBranco.e2f0b695.png";